import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { colors, fontSizes, fontWeights, spacing } from 'syf-component-library/defaultTheme';
import { MessageBox } from 'syf-component-library/ui/patterns';
import { H4, H5 } from 'syf-component-library/ui/typography';
export const SettlementTitle = styled(H5) `
  font-weight: ${fontWeights.light};
`;
export const MessageBoxContainer = styled(MessageBox) `
  padding: ${spacing.medium}px ${spacing.large}px;
`;
export const MessageBoxContent = styled.div `
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
`;
export const DetailsCard = styled.div `
  background: ${colors.white};
  margin-top: ${spacing.medium}px;
  padding: ${spacing.base}px;
  display: flex;
  gap: ${spacing.base}px;
  align-items: center;
  border: 2px solid #34657f;
  border-radius: ${spacing.small}px;
  font-size: 14px;
  font-weight: ${fontWeights.regular};
  flex-direction: column;

  @media ${query.greaterThanMedium} {
    flex-direction: row;
    gap: ${spacing.large}px;
  }
`;
export const DetailsCardSettlement = styled.div `
  display: flex;
  gap: ${spacing.medium}px;
  text-align: center;
  flex-direction: column;
  align-items: center;

  @media ${query.greaterThanMedium} {
    flex-direction: row;
    align-items: left;
  }
`;
export const DetailsCardAmount = styled.div `
  display: flex;
  flex-direction: column;

  > ${H4} {
    color: #34657f;
    font-weight: ${fontWeights.bold};
  }

  @media ${query.greaterThanMedium} {
    > ${H4} {
      text-align: left;
    }
  }
`;
export const DetailsCardPlan = styled.ul `
  list-style: none;
  margin: 0;
  padding-left: 0;
  padding-top: ${spacing.base}px;
  border-top: 1px solid #e0e0e0;
  width: 100%;
  text-align: left;

  @media ${query.greaterThanMedium} {
    width: auto;
    padding-top: 0;
    border-top: 0;
    border-left: 1px solid #e0e0e0;
    padding-left: ${spacing.large}px;
  }
`;
export const DetailsCardPlanInfo = styled.span `
  font-size: ${fontSizes.small}px;
`;
export const DetailsInfo = styled.div `
  font-weight: ${fontWeights.regular};
  font-size: ${fontSizes.small}px;
  padding-top: ${spacing.base}px;
`;
